import { jwtDecode } from "jwt-decode";
import { useAuth } from "../context/auth";
import ApiMenus from "../services/suporte/auth/menus";
import StorageItems from "../storage";

export const isTokenValid = (token?: string): boolean => {
  try {
    if (token) {
      const decodedToken: any = jwtDecode(token);
      const expirationDate: number = decodedToken.exp * 1000; // Convertendo para milissegundos
      const now: number = Date.now();
      return expirationDate > now;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const checkMenus = async () => {
  const menus = new StorageItems().get("menus");

  if (!menus) {
    const result = await new ApiMenus().menus();
    if (result.success) {
      new StorageItems().set("menus", result.data.menus);
    }
  }
};

export const checkAuth = () => {
  const { authToken } = useAuth();

  if (authToken) {
    return isTokenValid(authToken.authToken);
  }
  return false;
};
